import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Upload,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { Collapse } from "antd";
import "../../assets/css/custom.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonProductCard from "./CommonProductCard";
import CommonApplicationSelection from "./CommonApplicationSelection";
import PersonalDetails from "./PersonalDetails";
import VehicleDetails from "./VehicleDetails";
import EmploymentDetails from "./EmploymentDetails";
import GuarantorTabs from "./GuarantorTabs";
import Declaration from "./Declaration";
import { UploadOutlined } from "@ant-design/icons";
import ApplicationPreview from "./ApplicationPreview";
import ApplicationsOverview from "./ApplicationsOverview";
import MissingDocuments from "./MissingDocuments";
import { ServerAPI } from "../../common/ServerAPI";
import VehicleDocuments from "./VehicleDocuments";
import { toast } from "react-toastify";
import FileUploadWithThumbnails from "./FileUploadWithThumbnails";
import CommonDocumentUpload from "./CommonDocumentUpload";
import SignatureUpload from "./SignatureUpload";
import { InitialData } from "../../common/InitialData";
import {
  areSteps1To6Completed,
  checkValidations,
  clearLocalStorageExceptOne,
  hasKeysAndNotEmpty,
  isAnyKeyEmpty,
  reverseObject,
  validateRequiredFields,
} from "../../common/Utilities";
import { RequiredFields } from "../../common/RequiredFields";
import LoanSuccessModal from "./modals/LoanSuccessModal";
import ConfirmationModalApplicant from "./modals/ConfirmationModalApplicant";
import { FiCalendar, FiDollarSign } from "react-icons/fi";
import { FaCarSide, FaCar, FaCarAlt } from "react-icons/fa";
import ConfirmationModalLoanType from "./modals/ConfirmationModalLoanType";
import { useMutation, useQuery } from "react-query";
import axios from "../../axios/axios";
import PageLoader from "../../components/PageLoader";

const LoanApply = () => {
  const { loanId, singpassId } = useParams();
  const applicationno = localStorage.getItem("applicationno");
  const [pageLoaded, setPageLoaded] = useState(false);
  const [loanType, setLoanType] = useState("");
  const [filters, setFilters] = useState({});
  const [applicantTypeLabel, setApplicantTypeLable] = useState("");
  const [applicantValues, setApplicantValues] = useState({});
  const [loanTypeInfo, setLoanTypeInfo] = useState("");
  const [guarantorCount, setGuarantorCount] = useState(0);
  const [loanDetails, setLoanDetails] = useState({});
  const [draftMessage, setDraftMessage] = useState("");
  const [applicationStep, setApplicationStep] = useState(0);
  const [finalModal, setFinalModal] = useState(false);
  const [applicantModal, setApplicantModal] = useState(false);
  const [stepsCompleted, setStepsCompleted] = useState(false);
  const [applicantModalLoanType, setApplicantModalLoanType] = useState(false);
  const [applicantType, setApplicantType] = useState("");
  const [settingsData, setSettingsData] = useState({});
  const [loanCriterias, setLoanCriterias] = useState([]);
  const [vehicelDetail, setVehicleDetail] = useState({});
  const [vehicleDocumnets, setVehicleDocuments] = useState({});
  const [loading, setLoading] = useState(false);
  const [SingPassData, setSingPassData] = useState({});
  const [LogFile, setLogFile] = useState();
  const [existingGuarantors, setExistingGuarantors] = useState([]);

  const [stepCompletionData, setStepCompletionData] = useState(
    InitialData.stepStatus
  );

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [vehicleLoanTypeData, setVehicleLoanTypeData] = useState({});
  const [applyFilters, setApplyFilters] = useState({
    bonus: "",
    approvalTime: "", // Approval Time
    index: "0",
    keyword: "", // search
    loanType: "", // Type
    ltv: "", // Loan to Value
    motorType: "", // Motor
    toggleSwitch: "lt",
    //productType:"", // top filter
    scheme: "", // scheme
    sortKey: "created_at", // name
    sortOrder: "desc", // asc
    usage: "", // Usage,
    category: "",
  });

  const GetSingpassData = async () => {
    const resp = await axios.get(`/fetched/sg-myinfo/response/${loanId}`);
    if (resp.status < 400) {
      if (Number(resp.data?.data?.is_updated) === 0) {
        setSingPassData(resp.data?.data);
        updateSingpassDataAsUsed(loanId, resp.data?.data);
      } else {
        redirectFromSingPass(loanId);
      }
      loanApplicationUpdate("applicant_type", applicantType);
      stepStatusUpdater("step2", "completed", true);
      stepStatusUpdater("step2", "viewed", true);
    } else {
      toast.error("Couldn't fetch your singpass data..!");
    }
  };

  const updateSingpassDataAsUsed = async (loanId, singpassData) => {
    const tokenId = localStorage.getItem("dealerModuleToken");
    const resp = await axios.post(
      `/update/singpassinfo/status/${loanId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
    );
    updateSingPassApplicantInfo(loanId, singpassData);
  };

  const updateSingPassApplicantInfo = async (loanId, data) => {
    const tokenId = localStorage.getItem("dealerModuleToken");
    const resp = await axios.post(
      `/update/loan/applicant/info/${loanId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
    );
    redirectFromSingPass(loanId)
    handleNavigate(3);
  };

  const redirectFromSingPass = (loanId) => {
    setTimeout(() => {
      navigate(`/loan-apply/${loanId}`);
    }, 2000);
  }

  const updateApplicantType = async (type) => {
    const tokenId = localStorage.getItem("dealerModuleToken");
    setApplicantType(type);
    const resp = await axios.post(
      `/update/loan/applicant/type/${loanId}/${type}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
    );
    loanDataFetch();
  };

  useEffect(() => {
    if (singpassId !== undefined && singpassId !== null) {
      GetSingpassData();
    }
  }, [singpassId]);


  const {
    isLoading: loanDataLoad,
    data: loanData,
    refetch: loanDataFetch,
  } = useQuery(
    ["loanApplicationData", applicationStep],
    async () => {
      const tokenId = localStorage.getItem("dealerModuleToken");
      const resp = await axios.get(`/loan/application/info/${loanId}`, {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      });
      const respData = resp?.data?.data;
      setPageLoaded(true);
      setLoanDetails(respData);
      setFilters({
        category: respData?.category,
        loanType: respData?.loanType,
        loanamount: respData?.loanamount,
        tenure: String(respData?.tenure),
        vehicletype: respData?.loanType,
        parfvalue: respData?.parfvalue,
      });
      if (respData?.loanfor === null) {
        localStorage.setItem("step", 0);
      } else {
        setApplicationStep(respData?.activeStep);
        localStorage.setItem("step", respData?.activeStep);
        localStorage.setItem("loantype", respData?.loanfor);
        setLoanType(respData?.loanfor);
        localStorage.setItem(
          "loantypeinfo",
          respData?.loanforinfo?.loan_reason
        );
        setLoanTypeInfo(respData?.loanforinfo?.loan_reason);
        setStepCompletionData(respData?.stepStatus);
        localStorage.setItem(
          "stepStatus",
          JSON.stringify(respData?.stepStatus)
        );
      }
      localStorage.setItem("applicationno", loanId);
      if (respData?.applicant_details) {
        setApplicantType(respData?.applicant_details?.applicant_type);
        setApplicantTypeLable(
          respData?.applicant_details?.typeinfo?.applicant_type
        );
        localStorage.setItem(
          "applicanttypeid",
          respData?.applicant_details?.applicant_type
        );
        localStorage.setItem(
          "applicanttype",
          respData?.applicant_details?.typeinfo?.applicant_type
        );
      }
      if (respData?.vehicle_details) {
        const vehData = respData?.vehicle_details;
        if (respData?.category == "f96b81ae-7210-4332-80d2-070556ea724b") {
          let localData = {
            vehicle_reg_no: {
              value: vehData.vehicle_reg_no,
              validation: true,
            },
            customer_id_type: {
              value: vehData.customer_id_type,
              validation: true,
            },
            nationality: {
              value: vehData.nationality,
              validation: true,
            },
            owner_id: {
              value: vehData.owner_id,
              validation: true,
            },
            make_model: {
              value: vehData.make_model,
              validation: true,
            },
            opc_vehicle_id: {
              value: vehData.opc_vehicle_id,
              validation: true,
            },
            is_opc_car: {
              value: vehData.is_opc_car,
              validation: true,
            },
            vehicle_under_opc: {
              value: Number(vehData.vehicle_under_opc),
              validation: true,
            },
            vehicle_emission_scheme: {
              value: vehData.vehicle_emission_scheme,
              validation: true,
            },
            vehicle_coe_category: {
              value: vehData.vehicle_coe_category,
              validation: true,
            },
            vehicle_coe_amount: {
              value: vehData.vehicle_coe_amount,
              validation: true,
            },
            vehicle_ori_reg_date: {
              value: vehData.vehicle_ori_reg_date,
              validation: true,
            },
            vehicle_chassis_no: {
              value: vehData.vehicle_chassis_no,
              validation: true,
            },
            vehicle_engine_no: {
              value: vehData.vehicle_engine_no,
              validation: true,
            },
            vehicle_omv: {
              value: vehData.vehicle_omv,
              validation: true,
            },
            vehicle_purchase_price: {
              value: vehData.vehicle_purchase_price,
              validation: true,
            },
            vehicle_yom: {
              value: vehData.vehicle_yom,
              validation: true,
            },
            parf_rebate: {
              value: vehData.parf_rebate,
              validation: true,
            },
            coe_rebate: {
              value: vehData.coe_rebate,
              validation: true,
            },
            total_rebate: {
              value: vehData.total_rebate,
              validation: true,
            },
          };
          let localDataDoc = {
            sale_agreement: vehData.sale_agreement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: vehData.additional_documents.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            vehicle_overseas_log_card: vehData.vehicle_overseas_log_card.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            data_card: vehData.data_card.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            cargo_clearance_permits: vehData.cargo_clearance_permits.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            bill_of_lading: vehData.bill_of_lading.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            letter_of_newness: vehData.letter_of_newness.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
          };
          localStorage.setItem("vehicleDetails", JSON.stringify(localData));
          localStorage.setItem(
            "vehicleDocuments",
            JSON.stringify(localDataDoc)
          );
        } else {
          let localData = {
            vehicle_reg_no: {
              value: vehData.vehicle_reg_no,
              validation: true,
            },
            customer_id_type: {
              value: vehData.customer_id_type,
              validation: true,
            },
            nationality: {
              value: vehData.nationality,
              validation: true,
            },
            owner_id: {
              value: vehData.owner_id,
              validation: true,
            },
            make_model: {
              value: vehData.make_model,
              validation: true,
            },
            opc_vehicle_id: {
              value: vehData.opc_vehicle_id,
              validation: true,
            },
            is_opc_car: {
              value: vehData.is_opc_car,
              validation: true,
            },
          };
          let localDataDoc = {
            log_card: vehData?.log_card.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            sale_agreement: vehData.sale_agreement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: vehData.additional_documents.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
          };
          localStorage.setItem("vehicleDetails", JSON.stringify(localData));
          localStorage.setItem(
            "vehicleDocuments",
            JSON.stringify(localDataDoc)
          );
        }
      }
      if (
        respData?.applicant_details !== null &&
        respData?.applicant_details?.name !== ""
      ) {
        const applType = respData?.applicant_details?.typeinfo?.applicant_type;
        const applData = respData?.applicant_details;
        if (
          applType === "Singapore Citizen" ||
          applType === "Permenant Resident(PR)"
        ) {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
              validation: applData.title && applData.title !== '' ? true : false,
              //disabled: applData.title == '' ? false : true

            },
            name: {
              value: applData.name,
              validation: true,
              disabled: applData.name == '' ? false : true
            },
            nric: {
              value: applData.nric,
              validation: true,
              disabled: applData.nric == '' ? false : true
            },
            dob: {
              value: applData.dob,
              validation: true,
              disabled: applData.dob == '' ? false : true
            },
            gender: {
              value: applData.gender,
              validation: true,
              disabled: applData.gender == '' ? false : true
            },
            race: {
              value: applData.race,
              validation: true,
              disabled: applData.race == '' ? false : true
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
              disabled: applData.name_of_spouse == '' ? false : true
            },
            home_no: {
              value: applData.home_no,
              validation: true,
              disabled: applData.home_no == '' ? false : true

            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
              disabled: applData.mobile_no == '' ? false : true

            },
            office: {
              value: applData.office,
              validation: true,
              disabled: applData.office == '' ? false : true

            },
            email: {
              value: applData.email,
              validation: true,
              disabled: applData.email == '' ? false : true

            },
            marital_status: {
              value: applData.marital_status,
              validation: applData.marital_status && applData.marital_status !== '' ? true : false,
              disabled: applData.marital_status == '' ? false : true

            },
            residence_type: {
              value: applData.residence_type,
              validation: applData.residence_type && applData.residence_type !== '' ? true : false,
              disabled: applData.residence_type == '' ? false : true

            },
            home_address: {
              value: applData.home_address,
              validation: true,
              disabled: applData.home_address == '' ? false : true

            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
              disabled: applData.postal_code == '' ? false : true

            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
              disabled: applData.home_address_same_as_mailing == '' ? false : true

            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              disabled: applData.mailing_residence_type == '' ? false : true,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              disabled: applData.mailing_home_address == '' ? false : true,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              disabled: applData.mailing_postal_code == '' ? false : true,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
          };
          localStorage.setItem("applicant_details", JSON.stringify(localData));
        } else if (applType === "Work Pass Holder(FIN)") {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            dob: {
              value: applData.dob,
              validation: true,
            },
            gender: {
              value: applData.gender,
              validation: true,
            },
            race: {
              value: applData.race,
              validation: true,
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
            },
            home_no: {
              value: applData.home_no,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            marital_status: {
              value: applData.marital_status,
              validation: true,
            },
            residence_type: {
              value: applData.residence_type,
              validation: true,
            },
            home_address: {
              value: applData.home_address,
              validation: true,
            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            passport_expiry_date: {
              value: applData.passport_expiry_date,
              validation: true,
            },
            fin_no: {
              value: applData.fin_no,
              validation: true,
            },
            nationality: {
              value: applData.nationality,
              validation: true,
            },
          };
          localStorage.setItem("applicant_details", JSON.stringify(localData));
        } else if (applType === "Foreign Work Pass(Passport)") {
          let localData = {
            title: {
              value: applData.title,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            dob: {
              value: applData.dob,
              validation: true,
            },
            gender: {
              value: applData.gender,
              validation: true,
            },
            race: {
              value: applData.race,
              validation: true,
            },
            name_of_spouse: {
              value: applData.name_of_spouse,
              validation: true,
            },
            home_no: {
              value: applData.home_no,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            marital_status: {
              value: applData.marital_status,
              validation: true,
            },
            residence_type: {
              value: applData.residence_type,
              validation: true,
            },
            home_address: {
              value: applData.home_address,
              validation: true,
            },
            postal_code: {
              value: applData.postal_code,
              validation: true,
            },
            home_address_same_as_mailing: {
              value: applData.home_address_same_as_mailing,
              validation: true,
            },
            mailing_residence_type: {
              value: applData.mailing_residence_type,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_home_address: {
              value: applData.mailing_home_address,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            mailing_postal_code: {
              value: applData.mailing_postal_code,
              validation:
                applData.home_address_same_as_mailing == 0 ? false : true,
            },
            passport_expiry_date: {
              value: applData.passport_expiry_date,
              validation: true,
            },
            passport_no: {
              value: applData.passport_no,
              validation: true,
            },
            nationality: {
              value: applData.nationality,
              validation: true,
            },
          };
          localStorage.setItem("applicant_details", JSON.stringify(localData));
        } else {
          let localData = {
            company_name: {
              value: applData?.company_name,
              validation: true,
            },
            name: {
              value: applData.name,
              validation: true,
            },
            uen_acra_no: {
              value: applData.uen_acra_no,
              validation: true,
            },
            date_of_incorporation: {
              value: applData.date_of_incorporation,
              validation: true,
            },
            mobile_no: {
              value: applData.mobile_no,
              validation: true,
            },
            office: {
              value: applData.office,
              validation: true,
            },
            email: {
              value: applData.email,
              validation: true,
            },
            company_address: {
              value: applData.company_address,
              validation: true,
            },
            company_postal_code: {
              value: applData.company_postal_code,
              validation: true,
            },
            mailing_company_address: {
              value: applData.mailing_company_address,
              validation:
                applData.company_address_same_as_mailing == 0 ? false : true,
            },
            mailing_company_postal_code: {
              value: applData.mailing_company_postal_code,
              validation:
                applData.company_address_same_as_mailing == 0 ? false : true,
            },
            company_address_same_as_mailing: {
              value: applData.company_address_same_as_mailing,
              validation: true,
            },
          };
          localStorage.setItem("applicant_details", JSON.stringify(localData));
        }
      }
      if (respData?.applicant_employement_details) {
        const appEmpData = respData?.applicant_employement_details;
        const localData = {
          employment_type: {
            value: appEmpData.employment_type,
            validation: appEmpData.employment_type?.residence_type && appEmpData.employment_type?.residence_type !== '' ? true : false,
          },
          occupation: {
            value: appEmpData.occupation,
            validation: true,
          },
          type_of_industry: {
            value: appEmpData.type_of_industry,
            validation: true,
          },
          service_duration_years: {
            value: appEmpData.service_duration_years,
            validation: true,
          },
          service_duration_months: {
            value: appEmpData.service_duration_months,
            validation: true,
          },
          monthly_income: {
            value: appEmpData.monthly_income,
            validation: true,
          },
          other_income: {
            value: appEmpData.other_income,
            validation: true,
          },
          finance_type: {
            value: appEmpData.finance_type,
            validation: true,
          },
          employer_name: {
            value: appEmpData.employer_name,
            validation: true,
          },
          employer_address: {
            value: appEmpData.employer_address,
            validation: true,
          },
          employer_postal_code: {
            value: appEmpData.employer_postal_code,
            validation: true,
          },
          employer_previous_occupation: {
            value: appEmpData.employer_previous_occupation,
            validation: true,
          },
          employer_previous_name: {
            value: appEmpData.employer_previous_name,
            validation: true,
          },
          employer_previous_experience_years: {
            value: appEmpData.employer_previous_experience_years,
            validation: true,
          },
          employer_previous_experience_months: {
            value: appEmpData.employer_previous_experience_months,
            validation: true,
          },
          employer_previous_address: {
            value: appEmpData.employer_previous_address,
            validation: true,
          },
          employer_previous_postal_code: {
            value: appEmpData.employer_previous_postal_code,
            validation: true,
          },
        };
        localStorage.setItem(
          "applicant_employement_details",
          JSON.stringify(localData)
        );
      }
      if (respData?.applicant_documents) {
        const applDocuments = respData?.applicant_documents;
        const applType = respData?.applicant_details?.typeinfo?.applicant_type;
        if (
          applType === "Singapore Citizen" ||
          applType === "Permenant Resident(PR)"
        ) {
          let localData = {
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            cpf: applDocuments.cpf.map((item) => {
              return {
                name: item.name,
                value: item.value,
                disabled: true
              };
            }),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            nao: applDocuments.nao.map((item) => {
              return {
                name: item.name,
                value: item.value,
                disabled: true
              };
            }),
            nric: applDocuments.nric.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: "companyStamp",
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: "applicantSignature",
              value: applDocuments.applicant_signature,
            },
          };

          localStorage.setItem(
            "applicant_documents",
            JSON.stringify(localData)
          );
        } else if (applType === "Work Pass Holder(FIN)") {
          let localData = {
            work_permit: applDocuments.work_permit.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            pay_slip: applDocuments.pay_slip.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            nao: applDocuments.nao.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            appoinment_letter: applDocuments.appoinment_letter.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: "companyStamp",
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: "applicantSignature",
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            "applicant_documents",
            JSON.stringify(localData)
          );
        } else if (applType === "Foreign Work Pass(Passport)") {
          let localData = {
            passport: applDocuments.passport.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            bank_statement: applDocuments.bank_statement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            pay_slip: applDocuments.pay_slip.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            driving_license: applDocuments.driving_license.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            employment_letter: applDocuments.employment_letter.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            company_stamp: {
              name: "companyStamp",
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: "applicantSignature",
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            "applicant_documents",
            JSON.stringify(localData)
          );
        } else {
          let localData = {
            company_acra: applDocuments.company_acra.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            balance_sheet: applDocuments.balance_sheet.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            p_l_document: applDocuments.p_l_document.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            bank_statement: applDocuments.bank_statement.map((item) => {
              return {
                name: item.name,
                value: item.value,
              };
            }),
            additional_documents: applDocuments.additional_documents.map(
              (item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }
            ),
            company_stamp: {
              name: "companyStamp",
              value: applDocuments.company_stamp,
            },
            applicant_signature: {
              name: "applicantSignature",
              value: applDocuments.applicant_signature,
            },
          };
          localStorage.setItem(
            "applicant_documents",
            JSON.stringify(localData)
          );
        }
      }
      if (respData?.guarantorDetails) {
        const guarantorData = respData?.guarantorDetails;
        const guarantorLength = guarantorData.length;
        setExistingGuarantors(guarantorData);
        localStorage.setItem("guarantorcount", guarantorLength);
        guarantorData.map((gData, idx) => {
          const g_details = {
            guarantor_type: gData.guarantor_type,
            guarantor_citizenship_type: gData.guarantor_citizenship_type,
          };
          localStorage.setItem(`guarantor_id_${idx + 1}`, gData.id);

          if (gData.guarantor_type == "individual") {
            // Helper functions for safe access
            const getValue = (obj, key) => obj?.[key] ?? "";
            const isDisabled = (obj, key) => obj?.[key] ? true : false;
            const getValidation = (condition) => condition ? true : false;

            // Safely build personal details object
            const g_personal_details = {
              title: {
                value: getValue(gData?.personal_details, 'title'),
                validation:
                  getValue(gData?.personal_details, 'title') &&
                    getValue(gData?.personal_details, 'title') !== ''
                    ? true
                    : false,
                disabled: isDisabled(gData?.personal_details, 'title'),
              },
              name: {
                value: getValue(gData?.personal_details, 'name'),
                validation: true,
                disabled: isDisabled(gData?.personal_details, 'name')
              },
              nric: {
                value: getValue(gData?.personal_details, 'nric'),
                disabled: isDisabled(gData?.personal_details, 'nric')
              },
              dob: {
                value: getValue(gData?.personal_details, 'dob'),
                disabled: isDisabled(gData?.personal_details, 'dob')
              },
              gender: {
                value: getValue(gData?.personal_details, 'gender'),
                disabled: isDisabled(gData?.personal_details, 'gender')
              },
              race: {
                value: getValue(gData?.personal_details, 'race'),
                disabled: isDisabled(gData?.personal_details, 'race')
              },
              name_of_spouse: {
                value: getValue(gData?.personal_details, 'name_of_spouse'),
                disabled: isDisabled(gData?.personal_details, 'name_of_spouse')
              },
              home_no: {
                value: getValue(gData?.personal_details, 'home_no'),
                disabled: isDisabled(gData?.personal_details, 'home_no')
              },
              mobile_no: {
                value: getValue(gData?.personal_details, 'mobile_no'),
                disabled: isDisabled(gData?.personal_details, 'mobile_no')
              },
              office: {
                value: getValue(gData?.personal_details, 'office'),
                disabled: isDisabled(gData?.personal_details, 'office')
              },
              email: {
                value: getValue(gData?.personal_details, 'email'),
                disabled: isDisabled(gData?.personal_details, 'email')
              },
              marital_status: {
                value: getValue(gData?.personal_details, 'marital_status'),
                validation:
                  getValue(gData?.personal_details, 'marital_status') &&
                    getValue(gData?.personal_details, 'marital_status') !== ''
                    ? true
                    : false,
                disabled: isDisabled(gData?.personal_details, 'marital_status'),
              },
              residence_type: {
                value: getValue(gData?.personal_details, 'residence_type'),
                validation:
                  getValue(gData?.personal_details, 'residence_type') &&
                    getValue(gData?.personal_details, 'residence_type') !== ''
                    ? true
                    : false,
                disabled: isDisabled(gData?.personal_details, 'residence_type')
              },
              home_address: {
                value: getValue(gData?.personal_details, 'home_address'),
                disabled: isDisabled(gData?.personal_details, 'home_address')
              },
              postal_code: {
                value: getValue(gData?.personal_details, 'postal_code'),
                disabled: isDisabled(gData?.personal_details, 'postal_code')
              },
              home_address_same_as_mailing: {
                value: getValue(gData?.personal_details, 'home_address_same_as_mailing'),
                disabled: isDisabled(gData?.personal_details, 'home_address_same_as_mailing')
              },
              mailing_residence_type: {
                value: getValue(gData?.personal_details, 'mailing_residence_type'),
                validation: getValidation(
                  gData?.personal_details?.home_address_same_as_mailing === 0 &&
                  !gData?.personal_details?.mailing_residence_type
                )
              },
              mailing_home_address: {
                value: getValue(gData?.personal_details, 'mailing_home_address'),
                validation: getValidation(
                  gData?.personal_details?.home_address_same_as_mailing === 0 &&
                  !gData?.personal_details?.mailing_home_address
                )
              },
              mailing_postal_code: {
                value: getValue(gData?.personal_details, 'mailing_postal_code'),
                validation: getValidation(
                  gData?.personal_details?.home_address_same_as_mailing === 0 &&
                  !gData?.personal_details?.mailing_postal_code
                )
              },
            };
            console.log("g_personal_details===", g_personal_details)
            localStorage.setItem(
              `guarantor_personal_details_${idx + 1}`,
              JSON.stringify(g_personal_details)
            );
            const g_docs = {
              additional_documents: gData.documents.additional_documents.map(
                (item) => {
                  return {
                    name: item.name,
                    value: item.value,
                  };
                }
              ),
              cpf: gData.documents.cpf.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                  disabled: true

                };
              }),
              driving_license: gData.documents.driving_license.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              nao: gData.documents.nao.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                  disabled: true
                };
              }),
              bank_statement: gData.documents.bank_statement.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              nric: gData.documents.nric.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
            };
            localStorage.setItem(
              `guarantor_documents_${idx + 1}`,
              JSON.stringify(g_docs)
            );
            const g_emp_details = {
              employment_type: { value: getValue(gData?.employement_details, 'employment_type'), validation: getValidation(true) },
              occupation: { value: getValue(gData?.employement_details, 'occupation'), validation: getValidation(true) },
              type_of_industry: { value: getValue(gData?.employement_details, 'type_of_industry'), validation: getValidation(true) },
              service_duration_years: { value: getValue(gData?.employement_details, 'service_duration_years'), validation: getValidation(true) },
              service_duration_months: { value: getValue(gData?.employement_details, 'service_duration_months'), validation: getValidation(true) },
              monthly_income: { value: getValue(gData?.employement_details, 'monthly_income'), validation: getValidation(true) },
              other_income: { value: getValue(gData?.employement_details, 'other_income'), validation: getValidation(true) },
              finance_type: { value: getValue(gData?.employement_details, 'finance_type'), validation: getValidation(true) },
              employer_name: { value: getValue(gData?.employement_details, 'employer_name'), validation: getValidation(true) },
              employer_address: { value: getValue(gData?.employement_details, 'employer_address'), validation: getValidation(true) },
              employer_postal_code: { value: getValue(gData?.employement_details, 'employer_postal_code'), validation: getValidation(true) },
              employer_previous_occupation: { value: getValue(gData?.employement_details, 'employer_previous_occupation'), validation: getValidation(true) },
              employer_previous_name: { value: getValue(gData?.employement_details, 'employer_previous_name'), validation: getValidation(true) },
              employer_previous_experience_years: { value: getValue(gData?.employement_details, 'employer_previous_experience_years'), validation: getValidation(true) },
              employer_previous_experience_months: { value: getValue(gData?.employement_details, 'employer_previous_experience_months'), validation: getValidation(true) },
              employer_previous_address: { value: getValue(gData?.employement_details, 'employer_previous_address'), validation: getValidation(true) },
              employer_previous_postal_code: { value: getValue(gData?.employement_details, 'employer_previous_postal_code'), validation: getValidation(true) },
            };
            localStorage.setItem(
              `guarantor_employement_details_${idx + 1}`,
              JSON.stringify(g_emp_details)
            );
          }
          if (gData.guarantor_type == "company") {
            const g_personal_details = {
              company_name: {
                value: gData.personal_details?.company_name,
                validation: true,
              },
              uen_acra_no: {
                value: gData.personal_details.uen_acra_no,
                validation: true,
              },
              date_of_incorporation: {
                value: gData.personal_details.date_of_incorporation,
                validation: true,
              },
              mobile_no: {
                value: gData.personal_details.mobile_no,
                validation: true,
              },
              office: {
                value: gData.personal_details.office,
                validation: true,
              },
              email: {
                value: gData.personal_details.email,
                validation: true,
              },
              company_address: {
                value: gData.personal_details.company_address,
                validation: true,
              },
              company_postal_code: {
                value: gData.personal_details.company_postal_code,
                validation: true,
              },
              company_address_same_as_mailing: {
                value: gData.personal_details.company_address_same_as_mailing,
                validation: true,
              },
              mailing_company_address: {
                value: gData.personal_details.mailing_company_address,
                validation:
                  gData.personal_details.company_address_same_as_mailing == 0 &&
                    gData.personal_details.mailing_company_address === ""
                    ? false
                    : true,
              },
              mailing_company_postal_code: {
                value: gData.personal_details.mailing_company_postal_code,
                validation:
                  gData.personal_details.company_address_same_as_mailing == 0 &&
                    gData.personal_details.mailing_company_postal_code === ""
                    ? false
                    : true,
              },
            };
            localStorage.setItem(
              `guarantor_personal_details_${idx + 1}`,
              JSON.stringify(g_personal_details)
            );
            const g_docs = {
              company_acra: gData.documents.company_acra.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              p_l_document: gData.documents.p_l_document.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              balance_sheet: gData.documents.balance_sheet.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              bank_statement: gData.documents.bank_statement.map((item) => {
                return {
                  name: item.name,
                  value: item.value,
                };
              }),
              additional_documents: gData.documents.additional_documents.map(
                (item) => {
                  return {
                    name: item.name,
                    value: item.value,
                  };
                }
              ),
            };
            localStorage.setItem(
              `guarantor_documents_${idx + 1}`,
              JSON.stringify(g_docs)
            );
          }
          const g_sign = {
            company_stamp: {
              name: "companyStamp",
              value: gData.documents.company_stamp,
            },
            guarantor_signature: {
              name: "guarantorSignature",
              value: gData.documents?.guarantor_signature,
            },
          };
          localStorage.setItem(
            `guarantor_details_${idx + 1}`,
            JSON.stringify(g_details)
          );
          localStorage.setItem(
            `guarantor_sign_documents_${idx}`,
            JSON.stringify(g_sign)
          );
        });
      }
      if (respData?.applicant_declaration) {
        console.log("inside declaration")
        const appDeclData = respData?.applicant_declaration;
        console.log("inside declaration", appDeclData)
        const localData = {
          declaration_date: {
            value: appDeclData.declaration_date,
            validation: true,
          },
          form_data: {
            value: appDeclData.form_data,
            validation: true,
          },
        }
        console.log("jhsgadsajhdbakd", localData)
        localStorage.setItem("declarationDetails", JSON.stringify(localData));
      }
      return respData;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !pageLoaded,
    }
  );

  const { mutate: updateLoanInfo } = useMutation(async (postData) => {
    console.log("check1")
    const tokenId = localStorage.getItem("dealerModuleToken");
    const resp = await axios.post(
      `/update/loan/applicant/details/${loanId}`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
    );
    const respData = resp?.data?.data;
    return respData;
  });

  const stepStatusUpdater = (step, keydata, value) => {
    let updatedStepState = { ...stepCompletionData };
    updatedStepState[step][keydata] = value;
    setStepCompletionData(updatedStepState);

    updateLoanInfo({
      step_info: {
        stepStatus: updatedStepState,
      },
    });
    localStorage.setItem("stepStatus", JSON.stringify(updatedStepState));
  };

  const guarantorCountUpdate = (value) => {
    setGuarantorCount(value);
  };

  useEffect(() => {
    const unlisten = () => {
      // clearLocalStorageExceptOne('dealerModuleToken');
    };
    return () => {
      unlisten();
    };
  }, [navigate]);
  useEffect(() => {
    let applicantTypeData = localStorage.getItem("applicanttypeid");
    if (applicantTypeData) {
      setApplicantType(applicantTypeData);
    }
    let applicantTypeValue = localStorage.getItem("applicanttype");
    if (applicantTypeValue) {
      setApplicantTypeLable(applicantTypeValue);
    }
  }, [applicationStep]);

  const loanTypeData = async () => {
    const filterData = filters;
    const responseData = await ServerAPI.settingsData();
    if (responseData) {
      const getCategoryName = (categoryId) => {
        const category = responseData?.data?.categories.find(
          (item) => item.id === categoryId
        );
        return category ? category.name : "Category Not Found";
      };

      const getTypeName = (typeId) => {
        let typeName = "Type Not Found";
        responseData?.data?.categories.forEach((item) => {
          const type = item.types.find((type) => type.id === typeId);
          if (type) {
            typeName = type.name;
            return;
          }
        });
        return typeName;
      };
      let catId = getCategoryName(filterData.category);
      let typeId = getTypeName(filterData.loanType);
      setVehicleLoanTypeData({
        category: catId,
        type: typeId,
      });
    }

    const response = await ServerAPI.getLoanTypes(
      filterData.category,
      filterData.loanType
    );
    if (response) {
      setLoanCriterias(response.data);
    }
  };

  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      loanTypeData();
    }
  }, [filters]);


  const RetriveVehicleData = async (vechData) => {
    try {
      setLoading(true);
      const response = await ServerAPI.fileUpload(vechData.file);
      if (response.resp_code == 200) {
        let logCard = [{
          name: vechData?.vehicle_reg_no + ".pdf",
          value: response.data
        }]
        setVehicleDocuments({
          vehicle_overseas_log_card: logCard,
          log_card: logCard,
        });
        localStorage.setItem(
          "vehicleDocuments",
          JSON.stringify({
            vehicle_overseas_log_card: logCard,
            log_card: logCard,

          })
        );
      }

      setVehicleDetail({
        vehicle_reg_no: vechData?.vehicle_reg_no,
        access_code: vechData?.access_code,
        customer_id_type: vechData?.customer_id_type,
        nationality: vechData?.nationality,
        owner_id: vechData?.owner_id,
        make_model: vechData?.make_model,
        opc_vehicle_id: vechData?.opc_vehicle_id,
        is_opc_car: vechData?.is_opc_car,
        vehicle_under_opc: vechData?.vehicle_under_opc,
        vehicle_emission_scheme: vechData?.vehicle_emission_scheme,
        vehicle_coe_category: vechData?.vehicle_coe_category,
        vehicle_coe_amount: vechData?.vehicle_coe_amount,
        vehicle_ori_reg_date: vechData?.vehicle_ori_reg_date,
        vehicle_chassis_no: vechData?.vehicle_chassis_no,
        vehicle_engine_no: vechData?.vehicle_engine_no,
        vehicle_omv: vechData?.vehicle_omv,
        vehicle_purchase_price: vechData?.vehicle_purchase_price,
        vehicle_yom: vechData?.vehicle_yom,
        coe_rebate: vechData?.coe_rebate,
        parf_rebate: vechData?.parf_rebate,
        total_rebate: vechData?.total_rebate
      });

      setLoading(false);

    } catch (err) {
      toast.error("Vehicle details not fetched..!");
      setLoading(false);
    }
  };

  const StepOneItems = [
    {
      key: "1",
      label: "Loan Requirements",
      children: (
        <Fragment>
          <div className="">
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} md={8} lg={8}>
                <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                  Loan Amount
                </p>
                <InputNumber
                  type="number"
                  className="genrate_inp w-full cusInpDis"
                  addonBefore={<FiDollarSign color="white" fontSize={18} />}
                  placeholder="Loan Amount"
                  readOnly
                  value={loanDetails.loanamount}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="color-blue">
                {/* Content for the second part */}
                <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                  Tenure
                </p>
                <Input
                  min={12}
                  max={120}
                  className="genrate_inp w-full cusInpDis"
                  addonBefore={<FiCalendar color="white" fontSize={18} />}
                  placeholder="Loan Tenor (Months)"
                  readOnly
                  value={loanDetails.tenure + " Months "}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="color-blue">
                {/* Content for the third part */}
                <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                  Vehicle Category
                </p>
                <Input
                  min={12}
                  max={120}
                  className="genrate_inp w-full cusInpDis"
                  addonBefore={<FaCarAlt color="white" fontSize={18} />}
                  placeholder="Vehicle Category"
                  readOnly
                  value={vehicleLoanTypeData.category}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="color-blue">
                {/* Content for the third part */}
                <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                  Vehicle Type
                </p>
                <Input
                  min={12}
                  max={120}
                  className="genrate_inp w-full cusInpDis"
                  addonBefore={<FaCar color="white" fontSize={18} />}
                  placeholder="Vehicle Type"
                  readOnly
                  value={vehicleLoanTypeData.type}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="color-blue">
                {/* Content for the third part */}
                <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                  Loan For
                </p>
                <Input
                  min={12}
                  max={120}
                  className="genrate_inp w-full cusInpDis"
                  addonBefore={<FaCarSide color="white" fontSize={18} />}
                  placeholder="Loan For"
                  readOnly
                  value={loanTypeInfo}
                />
              </Col>
              {loanDetails.parfvalue != "0.00" && (
                <Col xs={24} sm={12} md={8} lg={8}>
                  {/* Content for the third part */}
                  <p className="text-[15px] font-[400] text-color-loan-sub-gray font-lato">
                    PARF Value
                  </p>
                  <InputNumber
                    type="number"
                    className={`genrate_inp w-full cusInpDis`}
                    addonBefore={<FiDollarSign color="white" fontSize={18} />}
                    placeholder="Min. PARF Value"
                    disabled={true}
                    value={loanDetails.parfvalue}
                  />
                </Col>
              )}
            </Row>
          </div>
        </Fragment>
      ),
    },
    {
      key: "2",
      label: "Banks(" + loanDetails.products?.Bank.length + ")",
      children: <CommonProductCard productData={loanDetails.products?.Bank} />,
    },
    {
      key: "3",
      label:
        "Financial Institutions(" +
        loanDetails.products?.Financial_Institution?.length +
        ")",
      children: (
        <CommonProductCard
          productData={loanDetails.products?.Financial_Institution}
        />
      ),
    },
    {
      key: "4",
      label: "In house(" + loanDetails.products?.["In-House"].length + ")",
      children: (
        <CommonProductCard productData={loanDetails.products?.["In-House"]} />
      ),
    },
    {
      key: "5",
      label: "Vehicle Details",
      children: (
        <VehicleDetails
          loanDetails={loanDetails}
          filterData={filters}
          productData={loanDetails?.vehicle_details}
          opcData={settingsData.opcvehicleTypes}
          updateFunction={stepStatusUpdater}
          RetriveVehicleData={RetriveVehicleData}
          RetriveVehicleDetails={vehicelDetail}
          loading={loading}
          setLogFile={setLogFile}
        />
      ),
    },
    {
      key: "6",
      label: "Upload Document",
      children: (
        <VehicleDocuments
          filterData={filters}
          productData={loanDetails?.vehicle_documents}
          updateFunction={stepStatusUpdater}
          vehicleDocumnets={vehicleDocumnets}
        />
      ),
    },
  ];

  const StepThreeItems = [
    {
      key: "1",
      label: "Particulars",
      children: (
        <PersonalDetails
          productData={loanDetails?.applicant_details}
          type={"applicant"}
          SingPassData={SingPassData}
        />
      ),
    },
    {
      key: "2",
      label: "Employment & Financial Declaration",
      children: (
        <EmploymentDetails
          type={"applicant"}
          productData={loanDetails?.applicant_employement_details}
          updateFunction={stepStatusUpdater}
          SingPassData={SingPassData}
        />
      ),
    },
  ];
  const StepThreeItemsCompany = [
    {
      key: "1",
      label: "Particulars",
      children: (
        <PersonalDetails
          type={"applicant"}
          updateFunction={stepStatusUpdater}
          SingPassData={SingPassData}
        />
      ),
    },
  ];
  const settingsInfo = async () => {
    const settings = await ServerAPI.settingsData();
    if (settings.data) {
      setApplyFilters({
        ...applyFilters,
        approvalTime: settings.data.approvalTimes[0].id,
        loanType: settings.data.categories[0].types[0].id,
        ltv: settings.data.ltvs[0].id,
        motorType: settings.data.productMotorTypes[0].id,
        scheme: settings.data.categories[0].types[0].schemes[0].id,
        usage: settings.data.productUsages[0].id,
        status: 1,
        category: settings.data.categories[0].id,
      });
      setSettingsData(settings.data);
    }
  };

  const loanApplicationUpdate = async (dataKeyValue, value) => {
    const response = await ServerAPI.updateApplication(dataKeyValue, value);
    console.log("loanApplicationUpdate", response)
    if (response) {
      toast.success(response.message);
    }
  };

  const handleLoanCreate = async () => {
    let loanApplicationData = location.state;
    let updatedData = { ...loanApplicationData };
    if (loanType == "") {
      toast.error("Please select the Loan Type to Proceed!");
    } else if (!loanApplicationData) {
      toast.error("Loan details not available!");
    } else {
      let type = localStorage.getItem("loantype");
      if (type) {
        updatedData["loanfor"] = type;
        delete updatedData.items;
        const response = await ServerAPI.updateLoanApplicationTypeInfo(
          updatedData
        );
        localStorage.setItem("loantype", loanType);
        localStorage.setItem("loantypeinfo", loanTypeInfo);
        if (response) {
          localStorage.setItem("applicationno", response.data.id);
          handleNavigate(1);
        }
      } else {
        setApplicantModalLoanType(true);
      }
    }
  };
  const handleNavigate = (stepValue) => {
    let stepDataResult = areSteps1To6Completed();
    if (stepValue > 6 && stepDataResult == false) {
      toast.error("Please complete all previous Steps to Proceed");
    } else {
      setApplicationStep(stepValue);
      updateLoanInfo({
        step_info: {
          activeStep: stepValue,
        },
      });
      localStorage.setItem("step", stepValue);
      window.scrollTo({ top: 0 });
    }
  };

  const guarantorValidator = () => {
    if (guarantorCount != 0) {
      let guarantorDetails = [];
      let totalCount = localStorage.getItem("guarantorcount");
      let validationResult = false;
      let validationCompletion = false;

      for (let index = 1; index <= totalCount; index++) {
        let data = {};
        let savedGuarantorData = JSON.parse(
          localStorage.getItem("guarantor_details_" + index)
        );
        let savedGuarantorDetails = JSON.parse(
          localStorage.getItem("guarantor_personal_details_" + index)
        );
        let savedGuarantorEmployemnt = JSON.parse(
          localStorage.getItem("guarantor_employement_details_" + index)
        );
        let savedGuarantorDocuments = JSON.parse(
          localStorage.getItem("guarantor_documents_" + index)
        );
        let savedGuarantorSignDocuments = JSON.parse(
          localStorage.getItem("guarantor_sign_documents_" + (index - 1))
        );
        let completionResultData = false;
        let completionResultEmployemnt = false;
        let completionResultDocuments = false;
        if (
          !savedGuarantorData ||
          !savedGuarantorDetails ||
          !savedGuarantorEmployemnt
        ) {
          validationResult = false;
        }
        if (!savedGuarantorDocuments) {
          validationCompletion = false;
        }
        if (savedGuarantorData && savedGuarantorDetails) {
          if (savedGuarantorData.guarantor_type == "company") {
            completionResultEmployemnt = true;
            completionResultData = hasKeysAndNotEmpty(
              savedGuarantorData,
              RequiredFields.guarantor_data_company
            );
          } else {
            completionResultData = hasKeysAndNotEmpty(
              savedGuarantorData,
              RequiredFields.guarantor_data_individual
            );
            completionResultEmployemnt = checkValidations(
              savedGuarantorEmployemnt
            );
          }
          let completionResultDetail = checkValidations(savedGuarantorDetails);
          if (savedGuarantorDocuments) {
            if (savedGuarantorData.guarantor_type == "individual") {
              completionResultDocuments = validateRequiredFields(
                savedGuarantorDocuments,
                RequiredFields.applicant_documents
              );
            } else {
              completionResultDocuments = validateRequiredFields(
                savedGuarantorDocuments,
                RequiredFields.company_applicant_documents
              );
            }
          }

          if (
            completionResultData == true &&
            completionResultDetail == true &&
            completionResultEmployemnt == true &&
            completionResultDocuments == false
          ) {
            validationResult = true;
            validationCompletion = false;
            data["guarantor_type"] = savedGuarantorData.guarantor_type;
            data["guarantor_citizenship_type"] =
              savedGuarantorData.guarantor_citizenship_type;
            data["guarantor_nric"] = savedGuarantorDetails.nric?.value
              ? savedGuarantorDetails?.nric?.value
              : savedGuarantorDetails?.uen_acra_no?.value;
            data["personal_details"] = reverseObject(savedGuarantorDetails);
            data["employement_details"] = reverseObject(
              savedGuarantorEmployemnt
            );
            data["documents"] = null;
          } else if (
            completionResultData == true &&
            completionResultDetail == true &&
            completionResultEmployemnt == true &&
            completionResultDocuments == true
          ) {
            validationResult = true;
            validationCompletion = true;
            data["guarantor_type"] = savedGuarantorData.guarantor_type;
            data["guarantor_citizenship_type"] =
              savedGuarantorData.guarantor_citizenship_type;
            data["guarantor_nric"] = savedGuarantorDetails.nric?.value
              ? savedGuarantorDetails?.nric?.value
              : savedGuarantorDetails?.uen_acra_no?.value;
            data["personal_details"] = reverseObject(savedGuarantorDetails);
            data["employement_details"] = reverseObject(
              savedGuarantorEmployemnt
            );
            data["documents"] = {
              ...savedGuarantorDocuments,
              guarantor_signature: savedGuarantorSignDocuments
                ?.guarantor_signature?.value
                ? savedGuarantorSignDocuments?.guarantor_signature?.value
                : "",
            };
          }
        }
        guarantorDetails.push(data);
      }
      if (validationCompletion == true && validationResult == true) {
        stepStatusUpdater("step5", "completed", true);
        stepStatusUpdater("step5", "viewed", true);
        loanApplicationUpdate("guarantor_details", guarantorDetails);
        handleNavigate(6);
      } else if (validationCompletion == false && validationResult == true) {
        stepStatusUpdater("step5", "viewed", true);
        stepStatusUpdater("step5", "completed", false);
        loanApplicationUpdate("guarantor_details", guarantorDetails);
        handleNavigate(6);
      } else {
        stepStatusUpdater("step5", "viewed", true);
        stepStatusUpdater("step5", "completed", false);
        handleNavigate(6);
      }
    } else {
      stepStatusUpdater("step5", "completed", true);
      stepStatusUpdater("step5", "viewed", true);
      handleNavigate(6);
    }
  };

  const declarationValidator = () => {
    let declarationDetails = JSON.parse(
      localStorage.getItem("declarationDetails")
    );
    if (declarationDetails) {
      console.log("if === declaration", declarationDetails)
      let validationResult = checkValidations(declarationDetails);
      if (validationResult != true) {
        //////////////////////////////////////
        stepStatusUpdater("step6", "completed", true);
        stepStatusUpdater("step6", "viewed", true);
        loanApplicationUpdate("applicant_declaration");
      }
    } else {
      console.log("false================================")
      stepStatusUpdater("step6", "viewed", true);
      stepStatusUpdater("step6", "completed", false);
    }
    stepsStatusChecker();
  };

  const stepsStatusChecker = () => {
    let stepDataResult = areSteps1To6Completed();
    if (stepDataResult == true) {
      handleNavigate(7);
    } else {
      toast.error("Please complete all previous Steps to Proceed");
    }
  };

  const signaturesValidator = () => {
    stepStatusUpdater("step8", "completed", true);
    stepStatusUpdater("step8", "viewed", true);
    handleNavigate(9);
  };
  const signatureHandler = (value) => {
    if (value == true) {
      setStepsCompleted(true);
    } else {
      setStepsCompleted(false);
    }
  };

  const stephandler = (value) => {
    let stepDetail = value;
    let savedValues = JSON.parse(localStorage.getItem(stepDetail));

    if (!savedValues) {
      if (value == "applicant_details") {
        stepStatusUpdater("step3", "viewed", true);
        stepStatusUpdater("step3", "completed", false);
      } else if (value == "vehicleDetails") {
        stepStatusUpdater("step1", "viewed", true);
        stepStatusUpdater("step1", "completed", false);
      } else if (value == "applicant_documents") {
        stepStatusUpdater("step4", "viewed", true);
        stepStatusUpdater("step4", "completed", false);
        handleNavigate(5);
      }
    } else {
      if (value == "applicant_details") {
        let validationresultData = checkValidations(savedValues);
        if (applicantTypeLabel == "Company") {
          if (validationresultData == true) {
            loanApplicationUpdate("applicant_details");
            stepStatusUpdater("step3", "viewed", true);
            stepStatusUpdater("step3", "completed", true);
          } else {
            loanApplicationUpdate("applicant_details");
            stepStatusUpdater("step3", "viewed", true);
            stepStatusUpdater("step3", "completed", false);
          }
        } else {
          let savedValues = JSON.parse(
            localStorage.getItem("applicant_employement_details")
          );
          let validationresultDataEmployment = checkValidations(savedValues);
          if (
            validationresultData == true &&
            validationresultDataEmployment == true
          ) {
            loanApplicationUpdate("applicant_details");
            stepStatusUpdater("step3", "viewed", true);
            stepStatusUpdater("step3", "completed", true);
          } else {
            loanApplicationUpdate("applicant_details");
            stepStatusUpdater("step3", "viewed", true);
            stepStatusUpdater("step3", "completed", false);
          }
        }
      } else if (value == "vehicleDetails") {
        let validationresultDataDocuments = true;
        let validationresultData = checkValidations(savedValues);
        let vehDocData = JSON.parse(localStorage.getItem("vehicleDocuments"));
        if (filters) {
          if (filters.category == "f96b81ae-7210-4332-80d2-070556ea724b") {
            validationresultDataDocuments = validateRequiredFields(
              vehDocData,
              RequiredFields.vehicle_documents_new
            );
          } else {
            validationresultDataDocuments = validateRequiredFields(
              vehDocData,
              RequiredFields.vehicle_documents
            );
          }
        }
        savedValues = reverseObject(savedValues);

        if (
          validationresultData == true &&
          validationresultDataDocuments == true
        ) {
          loanApplicationUpdate("vehicle_details");
          stepStatusUpdater("step1", "viewed", true);
          stepStatusUpdater("step1", "completed", true);
        } else {
          loanApplicationUpdate("vehicle_details");
          stepStatusUpdater("step1", "completed", false);
          stepStatusUpdater("step1", "viewed", true);
        }
      } else if (value == "applicant_documents") {
        let details = JSON.parse(localStorage.getItem("applicant_documents"));
        details = reverseObject(details);
        if (applicantTypeLabel == "Company") {
          let validationResults = validateRequiredFields(
            details,
            RequiredFields.company_applicant_documents
          );
          if (validationResults == true) {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", true);
            handleNavigate(5);
          } else {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", false);
            handleNavigate(5);
          }
        } else if (
          applicantTypeLabel == "Singapore Citizen" ||
          applicantTypeLabel == "Permenant Resident(PR)"
        ) {
          let validationResults = validateRequiredFields(
            details,
            RequiredFields.applicant_documents
          );
          if (validationResults == true) {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", true);
            handleNavigate(5);
          } else {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", false);
            handleNavigate(5);
          }
        } else if (applicantTypeLabel == "Foreign Work Pass(Passport)") {
          let validationResults = validateRequiredFields(
            details,
            RequiredFields.applicant_documents_fp
          );
          if (validationResults == true) {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", true);
            handleNavigate(5);
          } else {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", false);
            handleNavigate(5);
          }
        } else if (applicantTypeLabel == "Work Pass Holder(FIN)") {
          let validationResults = validateRequiredFields(
            details,
            RequiredFields.applicant_documents_wp
          );
          if (validationResults == true) {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", true);
            handleNavigate(5);
          } else {
            loanApplicationUpdate("applicant_documents");
            stepStatusUpdater("step4", "viewed", true);
            stepStatusUpdater("step4", "completed", false);
            handleNavigate(5);
          }
        }
      }
    }
  };

  const loanTypeChangeHandler = async (value) => {
    let loanApplicationData = location.state;
    if (value == true) {
      localStorage.setItem("loantype", loanType);
      localStorage.setItem("loantypeinfo", loanTypeInfo);
      let updatedData = { ...loanApplicationData };
      updatedData["loanfor"] = loanType;
      delete updatedData.items;
      const response = await ServerAPI.updateLoanApplicationTypeInfo(
        updatedData
      );
      if (response) {
        localStorage.setItem("applicationno", response.data.id);
        handleNavigate(1);
      }
    } else {
      let updatedData = { ...loanApplicationData };
      updatedData["loanfor"] = loanType;
      delete updatedData.items;
      const response = await ServerAPI.updateLoanApplicationTypeInfo(
        updatedData
      );
      if (response) {
        clearLocalStorageExceptOne(["dealerModuleToken", "filters"]);
        localStorage.setItem("loantype", loanType);
        localStorage.setItem("loantypeinfo", loanTypeInfo);
        localStorage.setItem("applicationno", response.data.id);
      }
      handleNavigate(1);
    }
  };

  const handleModalYesClick = () => {
    // Update the radio button value and close the modal
    setApplicantType(localStorage.getItem("applicanttypeid"));
    setApplicantTypeLable(localStorage.getItem("applicanttype"));
    stepStatusUpdater("step4", "viewed", false);
    stepStatusUpdater("step4", "completed", false);
    stepStatusUpdater("step3", "viewed", false);
    stepStatusUpdater("step3", "completed", false);
    setApplicantModal(false);
  };

  useEffect(() => {
    settingsInfo();

    // let stepData = localStorage.getItem('stepStatus');
    // if (stepData) {
    //     setStepCompletionData(JSON.parse(stepData));
    // }
  }, []);

  useEffect(() => {
    let signatureApplicantVerifier = false;
    let signatureGuarantorsVerifier = false;
    if (loanDetails) {
      if (loanDetails["applicant_documents"]?.["applicant_signature"] != "") {
        signatureApplicantVerifier = true;
      }
      if (
        loanDetails["guarantor_details"] != undefined &&
        loanDetails["guarantor_details"].length > 0
      ) {
        let guarantor_datas = loanDetails["guarantor_details"];
        guarantor_datas.map((data) => {
          if (data.documents?.guarantor_signature != "") {
            signatureGuarantorsVerifier = true;
          }
        });
      } else if (
        loanDetails["guarantor_details"] != undefined &&
        loanDetails["guarantor_details"].length == 0
      ) {
        signatureGuarantorsVerifier = true;
      } else {
        signatureApplicantVerifier = false;
        signatureGuarantorsVerifier = false;
      }
      if (
        signatureApplicantVerifier == true &&
        signatureGuarantorsVerifier == true
      ) {
        setStepsCompleted(true);
      } else {
        setStepsCompleted(false);
      }
    }
  }, [loanDetails]);

  useEffect(() => {
    if (localStorage.getItem("guarantorcount")) {
      setGuarantorCount(localStorage.getItem("guarantorcount"));
    }
    if (localStorage.getItem("applicantypeid")) {
      setApplicantType(localStorage.getItem("applicantypeid"));
    }
  }, [localStorage]);

  useEffect(() => {
    if (localStorage.getItem("applicantypeid")) {
      setApplicantType(localStorage.getItem("applicantypeid"));
    }
  }, []);

  useEffect(() => {
  }, [applicantType]);

  if (loanDataLoad) {
    return <PageLoader />;
  }

  return (
    <Fragment>
      <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
        <div className="bg-white">
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={24} md={17} lg={17}>
              <div className="text-[18px] font-[700] p-[18px_25px] bg-white">
                New Loan Application
              </div>
            </Col>
          </Row>
        </div>
        {/* Below Content Change based on the Step Value  */}
        {applicationStep == 0 && (
          <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_30px_14px_30px] mt-5 mx-5">
            <div className="text-[20px] font-[700] bg-white">
              I’m applying loan for
            </div>
            <div className="mt-4 loan-type">
              <Radio.Group
                buttonStyle="outline"
                onChange={(e) => {
                  setLoanType(e.target.value);
                  setLoanTypeInfo(e.target.id);
                  localStorage.setItem("loantype", e.target.value);
                  localStorage.setItem("loantypeinfo", e.target.id);
                }}
                value={loanType}
              >
                <Space direction="vertical">
                  {loanCriterias != undefined &&
                    loanCriterias.length > 0 &&
                    loanCriterias.map((criteria) => {
                      return (
                        <div
                          key={criteria.id}
                          className={
                            loanType == criteria.id
                              ? "max-w-full rounded border border-black h-15"
                              : "max-w-full rounded border border-search-border-color h-15"
                          }
                        >
                          <Radio
                            id={criteria.loan_reason}
                            className="my-3 mx-3"
                            value={criteria.id}
                          >
                            <div className="text-[13px] font-[500] text-color-loan-black">
                              {criteria.loan_reason}
                            </div>
                            <div className="text-color-loan-sub-gray text-[11px] font-[400]">
                              {criteria.description}
                            </div>
                          </Radio>
                          <div></div>
                        </div>
                      );
                    })}
                </Space>
              </Radio.Group>
            </div>
            <div className="mt-[100px] flex justify-end gap-3">
              {/* <Button className="floater_btn wh mr-[15px] w-[129px]" onClick={(e) => {
                                setApplicationStep(0);
                            }}>Back</Button> */}
              <Button
                type="primary"
                onClick={(e) => {
                  handleLoanCreate();
                }}
                className="floater_btn w-[129px]"
              >
                Next Step
              </Button>
            </div>
          </div>
        )}
        {applicationStep != 0 && applicationStep <= 8 && (
          <div className="step-list-group !max-w-[1550px]">
            <div
              className={`step-progress-list ${applicationStep > 1
                ? "compiled-step"
                : applicationStep == 1
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step1.viewed == true &&
                stepCompletionData.step1.completed == true && (
                  <h5>
                    Step 1
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step1.viewed == true &&
                stepCompletionData.step1.completed == false && (
                  <h5>
                    Step 1
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step1.viewed == false &&
                stepCompletionData.step1.completed == false && <h5>Step 1</h5>}
              <h4
                onClick={() => {
                  handleNavigate(1);
                }}
              >
                Finance & Vehicle
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 2
                ? "compiled-step"
                : applicationStep == 2
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step2.viewed == true &&
                stepCompletionData.step2.completed == true && (
                  <h5>
                    Step 2
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step2.viewed == true &&
                stepCompletionData.step2.completed == false && (
                  <h5>
                    Step 2
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step2.viewed == false &&
                stepCompletionData.step2.completed == false && <h5>Step 2</h5>}
              <h4
                onClick={() => {
                  stephandler("vehicleDetails");
                  handleNavigate(2);
                }}
              >
                Who is applicant
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 3
                ? "compiled-step"
                : applicationStep == 3
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step3.viewed == true &&
                stepCompletionData.step3.completed == true && (
                  <h5>
                    Step 3
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step3.viewed == true &&
                stepCompletionData.step3.completed == false && (
                  <h5>
                    Step 3
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step3.viewed == false &&
                stepCompletionData.step3.completed == false && <h5>Step 3</h5>}
              <h4
                onClick={() => {
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    loanApplicationUpdate("applicant_type", applicantType);
                    stepStatusUpdater("step2", "completed", true);
                    stepStatusUpdater("step2", "viewed", true);
                    handleNavigate(3);
                  } else {
                    loanApplicationUpdate("applicant_type", applicantType);
                    toast.warn("Please Select Applicant Type");
                    stepStatusUpdater("step2", "completed", false);
                    stepStatusUpdater("step2", "viewed", true);
                  }
                }}
              >
                Applicant’s Details
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 4
                ? "compiled-step"
                : applicationStep == 4
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step4.viewed == true &&
                stepCompletionData.step4.completed == true && (
                  <h5>
                    Step 4
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step4.viewed == true &&
                stepCompletionData.step4.completed == false && (
                  <h5>
                    Step 4
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step4.viewed == false &&
                stepCompletionData.step4.completed == false && <h5>Step 4</h5>}
              <h4
                onClick={() => {
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    stephandler("applicant_details");
                    handleNavigate(4);
                  } else {
                    toast.warn("Please Select Applicant Type");
                  }
                }}
              >
                Applicant’s Documents
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 5
                ? "compiled-step"
                : applicationStep == 5
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step5.viewed == true &&
                stepCompletionData.step5.completed == true && (
                  <h5>
                    Step 5
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step5.viewed == true &&
                stepCompletionData.step5.completed == false && (
                  <h5>
                    Step 5
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step5.viewed == false &&
                stepCompletionData.step5.completed == false && <h5>Step 5</h5>}
              <h4
                onClick={() => {
                  // stephandler("applicant_documents");
                  // handleNavigate(5);
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    stephandler("applicant_documents");
                    handleNavigate(5);
                  } else {
                    toast.warn("Please Select Applicant Type");
                  }
                }}
              >
                Guarantor Details
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 6
                ? "compiled-step"
                : applicationStep == 6
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step6.viewed == true &&
                stepCompletionData.step6.completed == true && (
                  <h5>
                    Step 6
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step6.viewed == true &&
                stepCompletionData.step6.completed == false && (
                  <h5>
                    Step 6
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step6.viewed == false &&
                stepCompletionData.step6.completed == false && <h5>Step 6</h5>}
              <h4
                onClick={() => {
                  // guarantorValidator();
                  // handleNavigate(6);
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    // stephandler("applicant_documents");
                    guarantorValidator();
                    handleNavigate(6);
                  } else {
                    toast.error("Complete all previous steps to preview.");
                  }
                }}
              >
                Declaration Letter
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 7
                ? "compiled-step"
                : applicationStep == 7
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step7.viewed == true &&
                stepCompletionData.step7.completed == true && (
                  <h5>
                    Step 7
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step7.viewed == true &&
                stepCompletionData.step7.completed == false && (
                  <h5>
                    Step 7
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step7.viewed == false &&
                stepCompletionData.step7.completed == false && <h5>Step 7</h5>}
              <h4
                onClick={() => {
                  // declarationValidator();
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    // stephandler("applicant_documents");
                    declarationValidator();
                    handleNavigate(7);
                  } else {
                    toast.error("Complete all previous steps to preview.");
                  }
                }}
              >
                Preview applicant form
              </h4>
            </div>
            <div
              className={`step-progress-list ${applicationStep > 8
                ? "compiled-step"
                : applicationStep == 8
                  ? "current-active"
                  : ""
                }`}
            >
              {stepCompletionData.step8.viewed == true &&
                stepCompletionData.step8.completed == true && (
                  <h5>
                    Step 8
                    <img src="/images/tick.png" />
                  </h5>
                )}
              {stepCompletionData.step8.viewed == true &&
                stepCompletionData.step8.completed == false && (
                  <h5>
                    Step 8
                    <img className="" src="/images/wrong.png" />
                  </h5>
                )}
              {stepCompletionData.step8.viewed == false &&
                stepCompletionData.step8.completed == false && <h5>Step 8</h5>}
              <h4
                onClick={() => {
                  // stepStatusUpdater("step7", "completed", true);
                  // stepStatusUpdater("step7", "viewed", true);
                  // handleNavigate(8);
                  let applicantType = localStorage.getItem("applicanttypeid");
                  if (applicantType) {
                    stepStatusUpdater("step7", "completed", true);
                    stepStatusUpdater("step7", "viewed", true);
                    handleNavigate(8);
                  } else {
                    toast.error("Complete all previous steps to preview.");
                  }

                }}
              >
                Signature
              </h4>
            </div>
          </div>
        )}
        {applicationStep == 1 && (
          <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
            <Collapse
              className="loanCollapse-apply"
              items={StepOneItems}
              defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
            />
            <div className="flex gap-2 flex-wrap justify-end mr-3">
              <Button
                className="floater_btn wh w-[129px]"
                onClick={(e) => {
                  handleNavigate(0);
                  sessionStorage.setItem('fromBackButton', 'true');
                }}
              >
                Back
              </Button>
              {/* <Button type="dashed" onClick={(e) => {
                                drafthandler('vehicleDetails');
                                handleNavigate(2);
                            }} className="floater_btn w-[129px] mr-[15px]">Save as Draft</Button> */}
              <Button
                type="primary"
                onClick={(e) => {
                  stephandler("vehicleDetails");
                  handleNavigate(2);
                  sessionStorage.setItem('fromBackButton', 'true');
                }}
                className="floater_btn w-[129px]"
              >
                Next Steps
              </Button>
            </div>
          </div>
        )}
        {applicationStep == 2 && (
          <Fragment>
            <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_30px_14px_30px] mt-5 mx-5">
              <div key={2} className="text-[20px] font-[700] bg-white">
                Who is the applicant?
              </div>
              <div className="mt-4">
                {settingsData != undefined &&
                  settingsData.loanApplicantTypes != undefined &&
                  settingsData.loanApplicantTypes.map((type) => {
                    return (
                      <Fragment>
                        <label
                          htmlFor={type.applicant_type}
                          key={type.id}
                          className={
                            applicantType === type.id
                              ? "border-step-color-active card-radio-group active"
                              : "card-radio-group mb-4"
                          }
                        >
                          <Radio
                            checked={applicantType === type.id ? true : false}
                            id={type.applicant_type}
                            value={type.id}
                            onChange={(e) => {
                              localStorage.setItem(
                                "applicanttypeid",
                                e.target.value
                              );
                              localStorage.setItem(
                                "applicanttype",
                                e.target.id
                              );
                              updateApplicantType(e.target.value);
                              if (applicantType != "") {
                                setApplicantModal(true);
                                let data = {
                                  id: e.target.value,
                                  value: e.target.id,
                                };
                                setApplicantValues(data);
                              } else {
                                localStorage.setItem(
                                  "applicanttypeid",
                                  e.target.value
                                );
                                localStorage.setItem(
                                  "applicanttype",
                                  e.target.id
                                );
                                setApplicantType(e.target.value);
                              }
                            }}
                          >
                            <div className="text-[13px] font-[500] text-color-loan-black">
                              {type.applicant_type}
                            </div>
                          </Radio>
                        </label>
                        {applicantType == type.id && (
                          <CommonApplicationSelection
                            singpassNeeded={
                              type.applicant_type ==
                                "Foreign Work Pass(Passport)" ||
                                type.applicant_type == "Company"
                                ? false
                                : true
                            }
                          />
                        )}
                      </Fragment>
                    );
                  })}
              </div>
              <div className="mt-[100px] flex justify-end gap-3">
                <Button
                  className="floater_btn wh mr-[15px] w-[129px]"
                  onClick={(e) => {
                    handleNavigate(1);
                  }}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  disabled={
                    localStorage.getItem("applicanttypeid") ? false : true
                  }
                  className="floater_btn w-[129px]"
                  onClick={(e) => {
                    let applicantType = localStorage.getItem("applicanttypeid");
                    if (applicantType) {
                      loanApplicationUpdate("applicant_type", applicantType);
                      stepStatusUpdater("step2", "completed", true);
                      stepStatusUpdater("step2", "viewed", true);
                      handleNavigate(3);
                    } else {
                      loanApplicationUpdate("applicant_type", applicantType);

                      toast.error("Please Choose Applicant");
                    }
                  }}
                >
                  Next Step
                </Button>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 3 && (
          <Fragment>
            <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
              {applicantTypeLabel == "Company" ? (
                <Collapse
                  className="loanCollapse-apply"
                  items={StepThreeItemsCompany}
                  defaultActiveKey={["1"]}
                />
              ) : (
                <Collapse
                  className="loanCollapse-apply"
                  items={StepThreeItems}
                  defaultActiveKey={["1", "2"]}
                />
              )}
              <div className="flex gap-2 flex-wrap justify-end mr-3">
                <Button
                  className="floater_btn wh w-[129px]"
                  onClick={(e) => {
                    handleNavigate(2);
                  }}
                >
                  Back
                </Button>
                {/* <Button type="dashed" onClick={(e) => {
                                    drafthandler('applicant_details');
                                    handleNavigate(4);
                                }} className="floater_btn w-[129px] mr-[15px]">Save as Draft</Button> */}
                <Button
                  type="primary"
                  onClick={(e) => {
                    stephandler("applicant_details");
                    handleNavigate(4);
                  }}
                  className="floater_btn w-[129px]"
                >
                  Next Step
                </Button>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 4 && (
          <Fragment>
            <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
              <div>
                <div className="text-[15px] font-[700] bg-white p-5 mb-[10px]">
                  Upload Document
                  <p className="form-field-label">
                    You can skip this step if documents are not ready.
                  </p>
                </div>
                <CommonDocumentUpload
                  documentHolderType={"applicant_documents"}
                  guarantor_index={0}
                  updateFunction={stepStatusUpdater}
                />
                <div className="flex gap-2 flex-wrap justify-end mr-3">
                  <Button
                    className="floater_btn wh w-[129px]"
                    onClick={(e) => {
                      handleNavigate(3);
                    }}
                  >
                    Back
                  </Button>
                  {/* <Button type="dashed" onClick={(e) => {
                                        stepStatusUpdater('step4', 'viewed', true);
                                        drafthandler('applicant_documents');
                                    }} className="floater_btn w-[129px] mr-[15px]">Save as Draft</Button> */}
                  <Button
                    type="primary"
                    onClick={(e) => {
                      stepStatusUpdater("step4", "viewed", true);
                      stephandler("applicant_documents");
                    }}
                    className="floater_btn w-[129px]"
                  >
                    Next Step
                  </Button>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 5 && (
          <Fragment>
            <div
              key={5}
              className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5"
            >
              <div>
                <div className="text-[20px] font-[700] bg-white p-5">
                  Add Guarantor (Max 4)
                </div>
                <GuarantorTabs
                  updateFunction={stepStatusUpdater}
                  guarantorCountUpdator={guarantorCountUpdate}
                  isApplicationGuarantor={false}
                  applicationID={loanId}
                  existingGuarantors={existingGuarantors}
                />

                <div className="flex gap-2 flex-wrap justify-end mr-3">
                  <Button
                    className="floater_btn wh w-[129px]"
                    onClick={(e) => {
                      handleNavigate(4);
                    }}
                  >
                    Back
                  </Button>
                  {/* <Button type="dashed" onClick={(e) => {
                                        guarantorValidator();
                                    }} className="floater_btn w-[129px] mr-[15px]">Save as Draft</Button> */}
                  <Button
                    type="primary"
                    onClick={(e) => {
                      guarantorValidator();
                    }}
                    className="floater_btn w-[129px]"
                  >
                    {guarantorCount == 0 ? "Skip" : "Next Step"}
                  </Button>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 6 && (
          <Fragment>
            <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
              <div>
                <div className="text-[20px] font-[700] bg-white p-5">
                  Declaration
                </div>
                <Declaration loanDetails={loanDetails} />
                <div className="flex gap-2 flex-wrap justify-end mr-3">
                  <Button
                    className="floater_btn wh w-[129px]"
                    onClick={(e) => {
                      handleNavigate(5);
                    }}
                  >
                    Back
                  </Button>
                  {/* <Button type="dashed" onClick={(e) => {
                                        declarationValidator();
                                    }} className="floater_btn w-[129px] mr-[15px]">Save as Draft</Button> */}
                  <Button
                    type="primary"
                    onClick={(e) => {
                      declarationValidator();
                    }}
                    className="floater_btn w-[129px]"
                  >
                    Next Step
                  </Button>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 7 && (
          <Fragment>
            <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
              <div className="application-preview-section">
                <ApplicationPreview />
              </div>
              <div className="flex gap-2 flex-wrap justify-end mr-3 mt-4">
                <Button
                  className="floater_btn wh w-[129px]"
                  onClick={(e) => {
                    handleNavigate(6);
                  }}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  onClick={(e) => {
                    stepStatusUpdater("step7", "completed", true);
                    stepStatusUpdater("step7", "viewed", true);
                    handleNavigate(8);
                  }}
                  className="floater_btn w-[129px]"
                >
                  Next Step
                </Button>
              </div>
            </div>
          </Fragment>
        )}
        {applicationStep == 8 && (
          <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
            <div className="mx-5">
              <div className="text-[20px] font-[700] bg-white p-5">
                Please upload the signature(s) for the application form(s)
              </div>
              <SignatureUpload updateFunction={signatureHandler} />
              <div className="flex gap-2 flex-wrap justify-end mr-3">
                <Button
                  className="floater_btn wh w-[129px]"
                  onClick={(e) => {
                    handleNavigate(7);
                    setDraftMessage("draft");
                    signaturesValidator();
                  }}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  onClick={(e) => {
                    setDraftMessage("completed");
                    signaturesValidator();
                  }}
                  className="floater_btn w-[129px]"
                  disabled={stepsCompleted == false ? true : false}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        )}
        {applicationStep == 9 && (
          <div className="ln_ap_shad bg-white border border-[#F4F4F4] rounded-[10px] max-w-full p-[20px_0px_14px_0px] mt-5 mx-5 px-5">
            <div className="mx-5">
              <div className="m-[0_auto] text-center">
                <div className="flex m-[0_auto] justify-center">
                  <img src="/images/final_tick.png" height={"auto"} />
                </div>
                <Fragment>
                  <div className="text-center">
                    <h2 className="text-xl font-bold mb-4 ">
                      Finalize Your Loan Application
                    </h2>
                    <p className="mb-4 max-w-[900px] mx-auto">
                      You're just one step away from moving forward with your
                      loan application. Please review your information
                      carefully. Once you're satisfied, choose the option that
                      aligns with your next action:
                    </p>
                  </div>
                  <div className="application-preview-section">
                    <ApplicationPreview />
                  </div>
                </Fragment>
              </div>
              <div className="flex gap-2 flex-wrap justify-end mt-4">
                <Button
                  type="default"
                  className="floater_btn w-[100%] md:w-[129px] mb-[10px] md:mb-0"
                  onClick={(e) => {
                    handleNavigate(8);
                  }}
                >
                  Back to edit
                </Button>
                {/* <Button type='dashed' className="floater_btn wh mr-[15px] w-[100%] md:w-[129px] mb-[10px] md:mb-0" onClick={(e) => {
                                    setFinalModal(true);
                                    setDraftMessage('draft');
                                }}>Save as Draft</Button> */}
                <Button
                  type="primary"
                  onClick={(e) => {
                    setFinalModal(true);
                    setDraftMessage("completed");
                  }}
                  className="floater_btn w-[100%] md:w-[129px] text-white"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        )}
        <LoanSuccessModal
          open={finalModal}
          close={() => {
            setFinalModal(false);
          }}
          message={draftMessage}
        />
        <ConfirmationModalApplicant
          open={applicantModal}
          close={() => {
            setApplicantModal(false);
          }}
          onYesClick={handleModalYesClick}
          id={applicantValues.id}
          value={applicantValues.value}
        />
        <ConfirmationModalLoanType
          close={() => {
            setApplicantModalLoanType(false);
          }}
          open={applicantModalLoanType}
          updateHandler={loanTypeChangeHandler}
        />
      </div>
    </Fragment >
  );
};

export default LoanApply;
